export default __webpack_public_path__ + "static/media/cloud_blocked.b4f3b75d.svg";